// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__28GRA","col":"Table_col__1bSPQ","fulfillmentStatus":"Table_fulfillmentStatus__bUmMs","emailCol":"Table_emailCol__1qcsf"};